var map = {
	"./acrobat.webp": 26513,
	"./alchemist.webp": 62497,
	"./alhadikhia.webp": 96496,
	"./alsaahir.webp": 4412,
	"./amnesiac.webp": 43104,
	"./angel.webp": 45513,
	"./apprentice.webp": 19641,
	"./artist.webp": 9142,
	"./assassin.webp": 44232,
	"./atheist.webp": 99730,
	"./balloonist.webp": 79498,
	"./banshee.webp": 77225,
	"./barber.webp": 5978,
	"./barista.webp": 2414,
	"./baron.webp": 83028,
	"./beggar.webp": 85083,
	"./bishop.webp": 47395,
	"./boffin.webp": 11555,
	"./bonecollector.webp": 39548,
	"./boomdandy.webp": 23150,
	"./bountyhunter.webp": 36727,
	"./buddhist.webp": 27040,
	"./bureaucrat.webp": 54405,
	"./butcher.webp": 60865,
	"./butler.webp": 17489,
	"./cacklejack.webp": 36805,
	"./cannibal.webp": 91473,
	"./cerenovus.webp": 96074,
	"./chambermaid.webp": 41400,
	"./chef.webp": 36692,
	"./choirboy.webp": 97228,
	"./clockmaker.webp": 52852,
	"./courtier.webp": 34871,
	"./cultleader.webp": 47866,
	"./custom.webp": 20279,
	"./damsel.webp": 23338,
	"./deusexfiasco.webp": 92821,
	"./deviant.webp": 50213,
	"./devilsadvocate.webp": 7691,
	"./djinn.webp": 2263,
	"./doomsayer.webp": 94323,
	"./dreamer.webp": 6702,
	"./drunk.webp": 98875,
	"./duchess.webp": 2477,
	"./empath.webp": 97027,
	"./engineer.webp": 83365,
	"./evil.webp": 33963,
	"./eviltwin.webp": 40634,
	"./exorcist.webp": 59531,
	"./fabled.webp": 2650,
	"./fanggu.webp": 54307,
	"./farmer.webp": 51953,
	"./fearmonger.webp": 48582,
	"./ferryman.webp": 30437,
	"./fibbin.webp": 60645,
	"./fiddler.webp": 35668,
	"./fisherman.webp": 4344,
	"./flowergirl.webp": 596,
	"./fool.webp": 7910,
	"./fortuneteller.webp": 32813,
	"./gambler.webp": 18417,
	"./gangster.webp": 46659,
	"./general.webp": 8804,
	"./gnome.webp": 85134,
	"./goblin.webp": 54891,
	"./godfather.webp": 56534,
	"./golem.webp": 45954,
	"./good.webp": 65741,
	"./goon.webp": 43462,
	"./gossip.webp": 59070,
	"./grandmother.webp": 59841,
	"./gunslinger.webp": 69703,
	"./harlot.webp": 72884,
	"./harpy.webp": 37347,
	"./hatter.webp": 93092,
	"./hellslibrarian.webp": 19358,
	"./heretic.webp": 85877,
	"./hermit.webp": 19493,
	"./highpriestess.webp": 3309,
	"./huntsman.webp": 80245,
	"./imp.webp": 58650,
	"./innkeeper.webp": 77549,
	"./investigator.webp": 97209,
	"./judge.webp": 11387,
	"./juggler.webp": 9063,
	"./kazali.webp": 49005,
	"./king.webp": 61951,
	"./klutz.webp": 84083,
	"./knight.webp": 20974,
	"./legion.webp": 57114,
	"./leviathan.webp": 12236,
	"./librarian.webp": 54889,
	"./lilmonsta.webp": 13444,
	"./lleech.webp": 59693,
	"./lordoftyphon.webp": 95554,
	"./lunatic.webp": 83213,
	"./lycanthrope.webp": 38682,
	"./magician.webp": 32382,
	"./marionette.webp": 10020,
	"./mastermind.webp": 55032,
	"./mathematician.webp": 88293,
	"./matron.webp": 67172,
	"./mayor.webp": 9604,
	"./mephit.webp": 57739,
	"./mezepheles.webp": 1986,
	"./minion.webp": 98531,
	"./minstrel.webp": 94721,
	"./monk.webp": 14359,
	"./moonchild.webp": 11778,
	"./mutant.webp": 87430,
	"./nightwatchman.webp": 57602,
	"./noble.webp": 64560,
	"./nodashii.webp": 2088,
	"./ogre.webp": 46377,
	"./ojo.webp": 39692,
	"./oracle.webp": 29083,
	"./organgrinder.webp": 14541,
	"./outsider.webp": 39508,
	"./pacifist.webp": 26059,
	"./philosopher.webp": 19671,
	"./pithag.webp": 21371,
	"./pixie.webp": 35453,
	"./plaguedoctor.webp": 48673,
	"./po.webp": 41913,
	"./poisoner.webp": 39718,
	"./politician.webp": 34615,
	"./poppygrower.webp": 30842,
	"./preacher.webp": 71883,
	"./princess.webp": 26045,
	"./professor.webp": 87658,
	"./psychopath.webp": 72860,
	"./pukka.webp": 19954,
	"./puzzlemaster.webp": 60782,
	"./ravenkeeper.webp": 84872,
	"./recluse.webp": 85801,
	"./revolutionary.webp": 87448,
	"./riot.webp": 25360,
	"./sage.webp": 44805,
	"./sailor.webp": 88739,
	"./saint.webp": 47275,
	"./savant.webp": 55954,
	"./scapegoat.webp": 16954,
	"./scarletwoman.webp": 44841,
	"./seamstress.webp": 42609,
	"./sentinel.webp": 13629,
	"./shabaloth.webp": 33057,
	"./shugenja.webp": 62822,
	"./slayer.webp": 68809,
	"./snakecharmer.webp": 59291,
	"./snitch.webp": 19481,
	"./soldier.webp": 89136,
	"./spiritofivory.webp": 20677,
	"./spy.webp": 3388,
	"./steward.webp": 73715,
	"./stormcatcher.webp": 3682,
	"./summoner.webp": 60816,
	"./sweetheart.webp": 47845,
	"./tealady.webp": 57889,
	"./thief.webp": 36024,
	"./tinker.webp": 6442,
	"./towncrier.webp": 39039,
	"./toymaker.webp": 31626,
	"./undertaker.webp": 68180,
	"./vigormortis.webp": 61871,
	"./villageidiot.webp": 89309,
	"./virgin.webp": 84783,
	"./vizier.webp": 13155,
	"./vortox.webp": 4858,
	"./voudon.webp": 17112,
	"./washerwoman.webp": 92614,
	"./widow.webp": 64745,
	"./witch.webp": 32634,
	"./wizard.webp": 39093,
	"./wraith.webp": 13274,
	"./xaan.webp": 55277,
	"./yaggababble.webp": 76577,
	"./zealot.webp": 71937,
	"./zombuul.webp": 63671
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95537;